import React, { useEffect, useState } from "react";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";
import { Link } from "react-router-dom";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { setCookie } from "../../helpers/CookieComponent";

const Webinar = () => {
  ChangeTitle("Webinar");
  const [mainMenu, setMainMenu] = useState("Upcoming Webinar");
  const [webinarType, setWebinarType] = useState(0);
  const [webinarList, setWebinarList] = useState([]);

  // Webinar List Api Call
  const viewWebinarList = async (type) => {
    const param = {
      type: type,
      offset: 0,
      limit: 0,
      sort: "",
      sortBy: "",
    };
    var response = await postData("webinar/user/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const webinarData = data.map((data) => {
        return {
          id: data._id,
          name: data.webinarName,
          fees: data.fees,
          isFree: data.isFree,
          date: data.date,
          image: data.thumbnailImage,
          noOfSession: data.noOfSession,
        };
      });
      setWebinarList(webinarData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewWebinarList(webinarType);
  }, [webinarType]);

  return (
    <>
      <div className="w-full p-[5%] section-books section-training section-webinar">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[2%]">
            <h1 className="hanson text-center mb-[1%] ap5-h1">Webinar</h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="w-full">
            <div className="relative z-[2] mb-[5%] w-max flex justify-evenly p-[2%] md:p-[1%] mx-auto rr-main-menu webinar-menu">
              <Link
                className={
                  webinarType == 0
                    ? "rrmm-box-active wm-box-active rrmm-box wm-box"
                    : "rrmm-box wm-box"
                }
                onClick={() => setWebinarType(0)}
              >
                Upcoming webinar
              </Link>
              <Link
                className={
                  webinarType == 1
                    ? "rrmm-box-active wm-box-active rrmm-box wm-box"
                    : "rrmm-box wm-box"
                }
                onClick={() => setWebinarType(1)}
              >
                Past webinar
              </Link>
            </div>
            {webinarList.length == 0 && (
              <h1 className="w-full text-center webinar-no-found">
                Webinar not exist
              </h1>
            )}
            {webinarList.length > 0 && (
              <div className="w-full mb-[5%] grid gap-10 sm:grid-cols-2 xl:grid-cols-3 upcoming-webinar">
                {webinarList.map((data) => (
                  <Link
                    to="/webinardetails"
                    onClick={() => setCookie("webinarId", data.id, {})}
                    className="h-full"
                  >
                    <div
                      // style={{
                      //   backgroundImage: `url(${data.image})`,
                      //   backgroundSize: "cover",
                      //   backgroundPosition: "center",
                      // }}
                      className="relative w-full h-max uw-box"
                    >
                      <img
                        className="w-full uwb-img object-cover"
                        src={data.image}
                        alt=""
                      />
                      <div className="absolute top-0 left-0 z-[5] w-full h-full flex items-end">
                        <div className="relative bottom-0 z-[2] px-[5%] py-[5%] w-[100%] mx-auto uwb-details">
                          <h1 className="uwbd-title mb-[5%] truncate">{data.name}</h1>
                          <div className="flex mb-[1%] gap-1 items-center">
                            <img
                              className="uwbd-h2"
                              src={toAbsoluteUrl(
                                "media/img/icon/basic/calendar-yellow.svg"
                              )}
                              alt=""
                            />
                            <h3 className="uwbd-h2">{data.date}</h3>
                          </div>
                          <div className="flex mb-[1%] gap-1">
                            <h2 className="uwbd-h2">Fees:</h2>
                            {data.isFree == true ? (
                              <h3 className="uwbd-h3">Free</h3>
                            ) : (
                              <h3 className="uwbd-h3">{data.fees}</h3>
                            )}
                          </div>
                          <div className="flex mb-[1%] gap-1">
                            <h2 className="uwbd-h2">No. of session(s):</h2>
                            <h3 className="uwbd-h3">{data.noOfSession}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Webinar;
